export default "curl -X POST {{url}} -H \"api-key: {{apiKey}}\" -F \"video={{video}}\" -F \"cmnd={{image}}\"\n"